import {
  ActualImplementation,
  DetailsOfExpensesReport,
  DirectionIndicators,
  ExpenseByArticlesReport,
  OrganizationClientsGrowth,
  RevenueStatement,
  SalaryReport,
} from '@app/pages/Analytics';
import { Authorization } from '@app/pages/Authorization';
import { BranchesList } from '@app/pages/Branches';
import { AddBranch } from '@app/pages/Branches/AddBranch';
import { ChainsList } from '@app/pages/Chains';
import { AddChain } from '@app/pages/Chains/AddChain';
import { ClientFields } from '@app/pages/ClientFields';
import {
  AddServiceCategory,
  ClientPaymentsHeader,
  ClientPaymentsList,
  ClientsExport,
  DetachResponsibleFromLead,
} from '@app/pages/Clients';
import { AddClient } from '@app/pages/Clients/AddClient/AddClient.main';
import { ClientsList } from '@app/pages/Clients/ClientsList/ClientsList.main';
import { EditClientService } from '@app/pages/Clients/EditClientService/EditClientService.main';
import { RecordsPageHeader, Records } from '@app/pages/Clients/Records';
import { ServicesSortingHeader } from '@app/pages/Clients/ServicesSorting/components/ServicesSortingHeader';
import { ControlPanel } from '@app/pages/ControlPanel';
import { DataMigrationHeader } from '@app/pages/DataMigration/components/DataMigrationHeader';
import { DataMigrationViewer } from '@app/pages/DataMigration/components/DataMigrationViewer';
import { DataMigration } from '@app/pages/DataMigration/DataMigration.main';
import { DocumentTemplates } from '@app/pages/DocumentTemplates';
import {
  EditEmployee,
  EmailChange,
  EmployeesList,
  SortEmployees,
} from '@app/pages/Employees';
import { AddEmployee } from '@app/pages/Employees/AddEmployee';
import { AddPosition } from '@app/pages/Employees/AddPosition';
import { Positions } from '@app/pages/Employees/Positions';
import { AddPaymentsAccount } from '@app/pages/Finances/AddPaymentAccounts/AddPaymentsAccount.main';
import { FinancialOperations } from '@app/pages/Finances/FinancialOperations/FinancialOperations.main';
import { PaymentAccountsPageHeader } from '@app/pages/Finances/PaymentAccountsList/components/PaymentAccountsPageHeader';
import { PaymentAccounts } from '@app/pages/Finances/PaymentAccountsList/PaymentAccounts.main';
import { Integrations, IntegrationsPageHeader } from '@app/pages/Integrations';
import { AddLegalEntities, LegalEntities } from '@app/pages/LegalEntities';
import { McpIntegration } from '@app/pages/McpIntegration';
import { Messages } from '@app/pages/Messages/MessagesList';
import { SalePlans } from '@app/pages/SalePlans';
import {
  EditSalesFunnel,
  EditSalesFunnelPageHeader,
  LogsRegistry,
  SalesFunnels,
  SalesFunnelsPageHeader,
  ViewSalesFunnel,
  ViewSalesFunnelPageHeader,
} from '@app/pages/SalesFunnels';
import { Settings } from '@app/pages/Settings';
import { Tags } from '@app/pages/Tags';
import { TaskListPage, TaskListPageHeader } from '@app/pages/TasksList';
import { UserPreview, UsersList } from '@app/pages/Users';
import { ActionsHistoryPage } from '@app/pages/Users/ActionsHistoryPage/ActionsHistoryPage.main';
import { AddUser } from '@app/pages/Users/AddUser';
import { EditUser } from '@app/pages/Users/EditUser';
import { UserProfile } from '@app/pages/Users/UserProfile';
import { WorkSchedule } from '@app/pages/WorkSchedule';

import { AiAgents } from './AiAgents';
import { AiPromptsSettings } from './AiPromptsSettings';
import { FinancialResultsReport } from './Analytics/FinancialResultsReport/ui';
export { ClientLeadCardPage, LeadCardPage, LeadsFunnels, Leads } from './Leads';
import { MedicalCardRegistry } from './MedicalCard';
import { ManageMessageTemplate } from './Messages/ManageMessageTemplate/ManageMessageTemplate.main';
import { MessageTemplatesRegistry } from './Messages/MessageTemplatesRegistry/MessageTemplatesRegistry.main';
import {
  RecordNotifications,
  SettingUpAutomaticMessagingToClients,
} from './Notifications';
import {
  OrganizationAnalytics,
  OrganizationsPageHeader,
} from './Organizations';
import { PaidAiFeatures } from './PaidAiFeatures';
import {
  PaymentDocumentsRegistry,
  PaymentDocumentsRegistryHeader,
  AddPaymentDocument,
} from './PaymentDocuments';
import { ProxyIntegration } from './ProxyIntegration';
import { AddProduct } from './Warehouses';
import {
  CreateWarehouse,
  WarehousesRegistry,
  WarehousesRegistryHeader,
} from './Warehouses/WarehouseRegistry';
import { YooKassaPaymentWithEmail, YooKassaSuccessPayment } from './YooKassa';
export { Sendouts, SendoutsPageHeader } from '@pages/Sendouts';
export { CalendarSettings } from '@pages/CalendarSettings';
export { ServiceCategories } from '@pages/ServiceCategories';
export { Booking } from '@pages/Booking';
export { Analytics } from '@pages/Analytics';
export { IntegrationParsing } from '@pages/IntegrationParsing';
export { NeuralNetworkLogs } from './NeuralNetworkLogs';
export { EmailLogs } from './EmailLogs';
export { DublicateClients } from './DublicateClients';
export { DublicateClientsSettings } from './DublicateClientsSettings';
export { CalendarHeader, CalendarPage } from './Calendar';
export {
  IndividualCalendarHeader,
  IndividualCalendarPage,
} from './IndividualCalendar';
export {
  Authorization,
  UsersList,
  ChainsList,
  AddChain,
  AddUser,
  BranchesList,
  AddBranch,
  ClientsList,
  UserProfile,
  EditUser,
  AddClient,
  Tags,
  ClientFields,
  EmployeesList,
  AddEmployee,
  Positions,
  AddPosition,
  EmailChange,
  EditEmployee,
  EditClientService,
  AddServiceCategory,
  UserPreview,
  WorkSchedule,
  RecordsPageHeader,
  LegalEntities,
  AddLegalEntities,
  PaymentAccounts,
  AddPaymentsAccount,
  PaymentAccountsPageHeader,
  Integrations,
  IntegrationsPageHeader,
  McpIntegration,
  ClientPaymentsList,
  ClientPaymentsHeader,
  DirectionIndicators,
  Settings,
  SalePlans,
  DataMigration,
  DataMigrationHeader,
  DataMigrationViewer,
  FinancialOperations,
  ActionsHistoryPage,
  ClientsExport,
  ControlPanel,
  Records,
  Messages,
  SortEmployees,
  ServicesSortingHeader,
  TaskListPage,
  TaskListPageHeader,
  SalesFunnels,
  SalesFunnelsPageHeader,
  ViewSalesFunnel,
  ViewSalesFunnelPageHeader,
  EditSalesFunnel,
  EditSalesFunnelPageHeader,
  MessageTemplatesRegistry,
  ManageMessageTemplate,
  OrganizationClientsGrowth,
  LogsRegistry,
  FinancialResultsReport,
  WarehousesRegistryHeader,
  WarehousesRegistry,
  CreateWarehouse,
  AddProduct,
  RevenueStatement,
  ActualImplementation,
  DetailsOfExpensesReport,
  ExpenseByArticlesReport,
  SalaryReport,
  SettingUpAutomaticMessagingToClients,
  RecordNotifications,
  AiAgents,
  AiPromptsSettings,
  PaidAiFeatures,
  ProxyIntegration,
  YooKassaSuccessPayment,
  PaymentDocumentsRegistry,
  PaymentDocumentsRegistryHeader,
  AddPaymentDocument,
  YooKassaPaymentWithEmail,
  DetachResponsibleFromLead,
  OrganizationsPageHeader,
  OrganizationAnalytics,
  MedicalCardRegistry,
  DocumentTemplates,
};
export { Portfolio } from './Portfolio';
